// components/GanttChart/LoadChartModal.js
import React from 'react';
import styled from 'styled-components';
// ChartItem 컴포넌트에 버튼 그룹 추가
const ChartItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  
  &:hover {
    background-color: #f9f9f9;
  }
`;

// 버튼 스타일 추가
const EditButton = styled.button`
  padding: 6px 12px;
  background-color: #FFC107;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-right: 8px;
  
  &:hover {
    background-color: #e0a800;
  }
`;

const DeleteButton = styled.button`
  padding: 6px 12px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-right: 8px;
  
  &:hover {
    background-color: #bd2130;
  }
`;
const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    padding: 16px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
  
  &:hover {
    color: #333;
  }
`;

const ChartList = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-bottom: 16px;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: #666;
  text-align: center;
`;



const ChartInfo = styled.div`
  flex: 1;
`;

const ChartTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 500;
`;

const ChartDate = styled.p`
  margin: 0;
  font-size: 12px;
  color: #666;
`;

const LoadButton = styled.button`
  padding: 6px 12px;
  background-color: #4EA8DE;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  
  &:hover {
    background-color: #3b86b5;
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;
const CancelButton = styled(Button)`
  background-color: #f1f1f1;
  color: #333;
  
  &:hover:not(:disabled) {
    background-color: #e1e1e1;
  }
`;

  // components/GanttChart/LoadChartModal.js (계속)
export default function LoadChartModal({ isOpen, onClose, charts, onLoad, isLoading,onEdit,onDelete }) {
  if (!isOpen) return null;
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('ko-KR', {
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit',
      hour: '2-digit', 
      minute: '2-digit'
    });
  };
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
          <ModalHeader>
            <Title>저장된 간트차트</Title>
            <CloseButton onClick={onClose}>&times;</CloseButton>
          </ModalHeader>
        
        <ChartList>
          {isLoading ? (
            <EmptyState>불러오는 중...</EmptyState>
          ) : charts.length === 0 ? (
            <EmptyState>
              <p>저장된 간트차트가 없습니다.</p>
              <p>새로운 차트를 만들고 저장해보세요!</p>
            </EmptyState>
          ) : (
            charts.map(chart => (
              <ChartItem key={chart.id}>
                <ChartInfo>
                  <ChartTitle>
                    {chart.title}
                    {chart.chart_type && (
                      <span style={{
                        marginLeft: 8,
                        display: 'inline-block',
                        padding: '2px 8px',
                        borderRadius: 999,
                        fontSize: 10,
                        fontWeight: 700,
                        verticalAlign: 'middle',
                        background: chart.chart_type === 'team' ? '#dbeafe' : '#f1f5f9',
                        color: chart.chart_type === 'team' ? '#1e40af' : '#475569',
                        border: `1px solid ${chart.chart_type === 'team' ? '#bfdbfe' : '#e5e7eb'}`,
                      }}>
                        {chart.chart_type === 'team' ? '👥 팀' : '👤 개인'}
                      </span>
                    )}
                  </ChartTitle>
                  <ChartDate>마지막 수정: {formatDate(chart.updated_at)}</ChartDate>
                </ChartInfo>
                <div>
                <EditButton 
                    onClick={() => onEdit(chart.id)}
                    disabled={isLoading}
                  >
                    편집
                  </EditButton>
                  <DeleteButton 
                    onClick={() => onDelete(chart.id)}
                    disabled={isLoading}
                  >
                    삭제
                  </DeleteButton>
                  <LoadButton 
                    onClick={() => onLoad(chart.id)}
                    disabled={isLoading}
                  >
                    불러오기
                  </LoadButton>
                </div>
              </ChartItem>
            ))
          )}
        </ChartList>
        
        <ButtonGroup>
          <CancelButton onClick={onClose} disabled={isLoading}>
            닫기
          </CancelButton>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
}